import { Route, Navigate, Outlet } from "react-router-dom";
import { useProductRouter } from "../Product/productRouter";
import { useIngredientRouter } from "../Ingredient/ingredientRouter";
import { useSupplierRouter } from "../Supplier/supplierRouter";
import { useClientSwitch } from "src/components/ClientSwitch/useClientSwitch";
import { useApplicationParameters } from "src/api/client-api/appParams";
import { CompanyTabs } from "./CompanyTabs";
import { companySlug } from "src/services/URLHandler";
import { RouterClientSwitch } from "src/components/ClientSwitch/RouterClientSwitch";
import { QuestionnaireUpdate } from "./Questionnaire/QuestionnaireUpdate/QuestionnaireUpdate";

import CompanyScoreContextProvider from "src/pages/Company/Scores/CompanyScoreContextProvider.tsx";
import { useTrajectoryCompanyRouter } from "./Trajectory/TrajectoryRouter";
import { CompanyScores } from "./Scores/CompanyScores";
import { Questionnaire } from "./Questionnaire/Questionnaire";
import { ScoreDetail } from "src/components/ScoreDetail/ScoreDetail";
// import { Synthesis } from "./Synthesis/Synthesis";
import { LegalRequirements } from "./LegalRequirements/LegalRequirements";
import { DimensionTreeSwitch } from "src/components/ScoreDetail/Dimensions/DimensionTreeSwitch";
import { CompanyScoresProvider } from "src/context/Company/Scores/provider";
import { CompanyMetadataProvider } from "src/context/Company/Metadata/provider";

export const useCompanyRouter = () => {
    const productRouter = useProductRouter();
    const ingredientRouter = useIngredientRouter();
    const supplierRouter = useSupplierRouter();
    const trajectoryCompanyRouter = useTrajectoryCompanyRouter();
    const clientSwitch = useClientSwitch();
    const { isFeatureActivated } = useApplicationParameters();

    const cs_defaultRedirect = clientSwitch({
        defaultOption: <Navigate to="questionnaire" replace />,
        // bred: <Navigate to="synthese" replace />,
        collective: <Navigate to="scores" replace />,
    });

    return (
        <Route path={`${companySlug}/:companyId`}>
            <Route index element={cs_defaultRedirect} />

            <Route element={<CompanyContext />}>
                {trajectoryCompanyRouter}
                <Route path="scores">
                    <Route element={<CompanyTabs section="scores" />}>
                        <Route index element={<CompanyScores />} />
                        <Route path=":scoreId" element={<CompanyScoreContext />}>
                            <Route index element={<ScoreDetail selectedTab={null} />} />
                            <Route path="distribution" element={<ScoreDetail selectedTab={"distribution"} />}>
                                <Route index element={<DimensionTreeSwitch mode={"distribution"} />} />
                            </Route>
                            <Route path="comparison" element={<ScoreDetail selectedTab={"comparison"} />}>
                                <Route index element={<DimensionTreeSwitch mode={"comparison"} />} />
                            </Route>
                            <Route path="evolution" element={<ScoreDetail selectedTab={"evolution"} />}>
                                <Route index element={<DimensionTreeSwitch mode={"evolution"} />} />
                            </Route>
                        </Route>
                    </Route>
                </Route>

                {/* Equivalent of /scores/, but for BRED. We want to get rid of it */}
                {/* <Route path="synthese" element={<RouterClientSwitch whitelistedMode={["bred"]} />}> */}
                {/* <Route
                    path="synthese"
                    element={isFeatureActivated("FS-legal-requirement") ? <Outlet /> : <Navigate to="/" replace />}
                >
                    <Route element={<CompanyTabs section="synthese" />}>
                        <Route index element={<Synthesis />} />
                    </Route>
                </Route> */}

                <Route
                    path="questionnaire"
                    element={<RouterClientSwitch whitelistedMode={["collective", "foodpilotLustucru"]} />}
                >
                    <Route element={<CompanyTabs section="questionnaire" />}>
                        <Route index element={<Questionnaire />} />
                    </Route>
                    <Route path="edit/:headingId" element={<QuestionnaireUpdate />} />
                </Route>

                <Route
                    path="requirements"
                    element={isFeatureActivated("FS-legal-requirement") ? <Outlet /> : <Navigate to="/" replace />}
                >
                    <Route element={<CompanyTabs section="exigences" />}>
                        <Route index element={<LegalRequirements />} />
                    </Route>
                </Route>
                {productRouter}
                {ingredientRouter}
                {supplierRouter}
            </Route>
        </Route>
    );
};

const CompanyContext = () => {
    return (
        <CompanyMetadataProvider>
            <CompanyScoresProvider>
                <Outlet />
            </CompanyScoresProvider>
        </CompanyMetadataProvider>
    );
};

const CompanyScoreContext = () => {
    return (
        <CompanyScoreContextProvider>
            <Outlet />
        </CompanyScoreContextProvider>
    );
};
